import React from 'react';

export const Check = React.memo(({ fill }) => (
  <>
    <path
      d='M22.7013 7.39989C22.8253 7.27328 22.9734 7.1727 23.1369 7.10403C23.3003 7.03537 23.4758 7 23.6531 7C23.8304 7 24.0059 7.03537 24.1693 7.10403C24.3327 7.1727 24.4808 7.27328 24.6049 7.39989C25.1249 7.92535 25.1322 8.77446 24.6231 9.30902L13.872 22.0184C13.7499 22.1524 13.6018 22.2601 13.4367 22.335C13.2715 22.4098 13.0929 22.4501 12.9116 22.4535C12.7304 22.4569 12.5503 22.4233 12.3825 22.3548C12.2147 22.2862 12.0626 22.1841 11.9356 22.0547L5.39363 15.4255C5.14133 15.1682 5 14.8222 5 14.4619C5 14.1015 5.14133 13.7555 5.39363 13.4982C5.51772 13.3716 5.66581 13.271 5.82925 13.2023C5.99269 13.1337 6.16819 13.0983 6.34547 13.0983C6.52275 13.0983 6.69824 13.1337 6.86168 13.2023C7.02512 13.271 7.17322 13.3716 7.29731 13.4982L12.8465 19.1219L22.6649 7.43989C22.6762 7.42584 22.6883 7.41248 22.7013 7.39989Z'
      fill={fill}
    />
  </>
));
Check.displayName = 'Check';
